var _defs, _sodipodiNamedview;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoodedIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: 800,
    width: 800,
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    sodipodidocname: "hooded_icon_red.svg",
    inkscapeversion: "1.2.1 (9c6d41e4, 2022-07-14)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs90"
  }, /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect4800",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect2298",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect2177",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect7598",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect6640",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect6640-7",
    is_visible: "true",
    lpeversion: 1
  }), /*#__PURE__*/React.createElement("inkscapepath-effect", {
    effect: "spiro",
    id: "path-effect4800-4",
    is_visible: "true",
    lpeversion: 1
  }))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview88",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapezoom: 7.2619868,
    inkscapecx: 159.39164,
    inkscapecy: 338.19946,
    "inkscapewindow-width": 3440,
    "inkscapewindow-height": 1302,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 25,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent--layer": "g4794-6",
    inkscapelockguides: "false",
    showguides: "false"
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    type: "xygrid",
    id: "grid4969"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.06173798,0,0,-0.06173798,590.6167,565.42159)",
    fill: "#ff0000",
    stroke: "none",
    id: "g8692",
    inkscapelabel: "iconM",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 207.935,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect5806",
    width: 346.72372,
    height: 335.35574,
    x: 2178.6226,
    y: -3465.054,
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 208.626,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 2351.9844,3297.3761 C 2096.9114,2921.8593 1695.1783,2648.8467 1252.1313,2549.9303 830.47042,2455.7887 375.45483,2519.6144 -4.0318058,2726.1342",
    id: "path6638",
    "inkscapeoriginal-d": "M 2351.9844,3297.3761 C 1985.3769,3048.2172 1618.7592,2799.0687 1252.1313,2549.9303 885.50321,2300.792 414.69952,2667.3892 -4.0318058,2726.1342",
    "inkscapepath-effect": "#path-effect6640"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4251",
    transform: "matrix(12.420592,0,0,-12.420592,3647.705,7882.3221)",
    style: {
      strokeWidth: 16.9997,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4162",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9997,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -27.12035,74.240873 a 130.21161,45.994675 0 0 1 0.529783,0.0098 c -0.02626,0.552098 -0.05582,1.103442 -0.05868,1.657815 -0.227797,4.941297 -0.51334,9.879009 -0.728657,14.820906 -0.335579,10.068175 -0.317857,20.145425 -0.590097,30.215605 -0.27198,12.61869 -0.476382,25.23724 -0.511853,37.85917 -0.02799,2.46466 -0.05873,4.93011 -0.09129,7.39578 A 130.21161,45.994675 0 0 1 -157.33305,120.23589 130.21161,45.994675 0 0 1 -27.12035,74.240873 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9997,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4162-9",
    sodipoditype: "arc",
    sodipodicx: -27.120817,
    sodipodicy: 385.79745,
    sodipodirx: 130.21161,
    sodipodiey: 45.994675,
    sodipodistart: 1.33301,
    sodipodiend: 3.1415927,
    "sodipodiarc-type": "arc",
    d: "M 3.5507644,430.49792 A 130.21161,45.994675 0 0 1 -107.6232,421.94868 130.21161,45.994675 0 0 1 -157.33243,385.79745",
    sodipodiopen: "true"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9997,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -157.33243,120.23511 v 265.56234 0",
    id: "path4243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse4760",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 3.46974,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -32.380629,93.327471 c 0.0046,0.44181 0.02674,0.883357 0.08054,1.3241 -0.970897,7.917939 -1.514542,15.879269 -2.145396,23.827919 -0.641735,7.62502 -1.240151,15.2533 -1.80809,22.88382 -0.187056,1.91715 -0.311658,3.83292 -0.346424,5.75004 a 104.35691,26.9779 0 0 1 -95.084241,-26.84286 104.35691,26.9779 0 0 1 99.303613,-26.943019 z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.08051146,0,0,-0.08051146,-10.561239,629.68197)",
    fill: "#ff0000",
    stroke: "none",
    id: "g4796",
    inkscapelabel: "iconG",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 207.93462198,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    id: "rect4780",
    width: 346.72372,
    height: 335.35574,
    x: 2178.6226,
    y: -3465.054,
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 208.62620054,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 2351.9844,3297.3761 C 2096.9114,2921.8593 1695.1783,2648.8467 1252.1313,2549.9303 830.47042,2455.7887 375.45483,2519.6144 -4.0318058,2726.1342",
    id: "path4782",
    "inkscapeoriginal-d": "M 2351.9844,3297.3761 C 1985.3769,3048.2172 1618.7592,2799.0687 1252.1313,2549.9303 885.50321,2300.792 414.69952,2667.3892 -4.0318058,2726.1342",
    "inkscapepath-effect": "#path-effect4800"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4794",
    transform: "matrix(12.420592,0,0,-12.420592,3647.705,7882.3221)",
    style: {
      strokeWidth: 16.99968007,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse4784",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.99968007,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -27.120816,74.240291 a 130.21161,45.994675 0 0 0 -130.211254,45.994999 130.21161,45.994675 0 0 0 130.211254,45.995 130.21161,45.994675 0 0 0 130.211246,-45.995 130.21161,45.994675 0 0 0 -130.211246,-45.994999 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.99968007,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4786",
    sodipoditype: "arc",
    sodipodicx: -27.120817,
    sodipodicy: 385.79745,
    sodipodirx: 130.21161,
    sodipodiry: 45.994675,
    sodipodistart: 0,
    sodipodiend: 3.1415927,
    "sodipodiarc-type": "arc",
    d: "m 103.09079,385.79745 a 130.21161,45.994675 0 0 1 -65.105804,39.83256 130.21161,45.994675 0 0 1 -130.211611,0 130.21161,45.994675 0 0 1 -65.105805,-39.83256",
    sodipodiopen: "true"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4788",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.99968007,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -157.33207,120.23529 v 265.5625 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.99968007,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 103.09079,120.23511 V 385.79745",
    id: "path4790"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 3.22776,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "ellipse4792",
    cx: -26.797636,
    cy: 120.23529,
    rx: 98.237022,
    ry: 24.800508
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.04892991,0,0,-0.04892991,-42.712937,504.45452)",
    fill: "#ff0000",
    stroke: "none",
    id: "g4796-1",
    inkscapelabel: "iconP",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 207.935,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect4780-8",
    width: 346.72372,
    height: 335.35574,
    x: 2178.6226,
    y: -3465.054,
    transform: "scale(1,-1)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff0000",
      strokeWidth: 208.626,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 2351.9844,3297.3761 C 2096.9114,2921.8593 1695.1783,2648.8467 1252.1313,2549.9303 830.47042,2455.7887 375.45483,2519.6144 -4.0318058,2726.1342",
    id: "path4782-2",
    "inkscapeoriginal-d": "M 2351.9844,3297.3761 C 1985.3769,3048.2172 1618.7592,2799.0687 1252.1313,2549.9303 885.50321,2300.792 414.69952,2667.3892 -4.0318058,2726.1342",
    "inkscapepath-effect": "#path-effect4800-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4794-6",
    transform: "matrix(12.420592,0,0,-12.420592,3647.705,7882.3221)",
    style: {
      strokeWidth: 16.9997,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "ellipse4784-0",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9997,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -27.121355,74.241297 a 130.21161,45.994675 0 0 0 -130.210205,45.994293 130.21161,45.994675 0 0 0 130.210205,45.99429 130.21161,45.994675 0 0 0 12.922911,-0.29823 c -0.02067,-0.89952 -0.05039,-1.79907 -0.06993,-2.69853 -0.17988,-9.28069 -0.217528,-18.56292 -0.255044,-27.84504 -0.142413,-8.4644 0.01158,-16.92025 0.364054,-25.37687 0.151529,-5.47075 0.502884,-10.920786 1.08188,-16.361892 0.37317,-2.840969 0.519796,-5.699385 0.617042,-8.560426 0.09642,-3.04176 0.133528,-6.085078 0.162488,-9.128105 0.0041,-0.4972 0.03005,-0.940279 0.04525,-1.408912 a 130.21161,45.994675 0 0 0 -14.868649,-0.310578 z",
    inkscapelabel: "ellipse4784-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9997,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4786-3",
    sodipoditype: "arc",
    sodipodicx: -27.120817,
    sodipodicy: 385.79745,
    sodipodirx: 130.21161,
    sodipodiey: 45.994675,
    sodipodistart: 1.4943402,
    sodipodiend: 3.1415927,
    "sodipodiarc-type": "arc",
    d: "m -17.175038,431.65776 a 130.21161,45.994675 0 0 1 -98.433092,-12.11793 130.21161,45.994675 0 0 1 -41.7243,-33.74238",
    sodipodiopen: "true",
    inkscapelabel: "path4786-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 16.9997,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -157.33243,120.23511 v 265.56234 0",
    id: "path4788-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse4792-9",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeWidth: 3.57208,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m -26.79623,93.027787 a 109.66734,27.208246 0 0 0 -109.66734,27.208743 109.66734,27.208246 0 0 0 109.66734,27.20686 109.66734,27.208246 0 0 0 10.556945,-0.17056 c -1.168524,-6.4071 -2.158595,-12.84234 -3.090526,-19.28245 -1.112054,-7.89069 -2.204823,-15.78332 -3.060305,-23.70199 -0.60636,-3.73047 -0.94187,-7.479895 -1.11412,-11.24186 a 109.66734,27.208246 0 0 0 -3.291994,-0.01875 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoodedIconRed);
export default __webpack_public_path__ + "static/media/hooded_icon_red.25b8d80f.svg";
export { ForwardRef as ReactComponent };